import React from "react";
import TriviaGame from "../triviaGame/TriviaGame";
import { QuestionRange } from "../triviaGame/utils";

export default function TriviaGame2025() {
  return <TriviaGame year={2025} questionRanges={QUESTION_RANGES_2025} questionBank={QUESTION_BANK_2025} />;
}

const QUESTION_RANGES_2025 = [
  new QuestionRange(0, 5),
  new QuestionRange(5, 10),
  new QuestionRange(10, 15),
  new QuestionRange(15, 20),
  new QuestionRange(20, 25),
];

const QUESTION_BANK_2025 = [
  {
  id: "202501",
  question: "Who pastry-toured around San Francisco via bicycle?",
  answer: "Liam",
  photo: "/assets/liam/2025/pastries.png",
  caption: "Arizmendi’s still my favorite",
},
{
  id: "202502",
  question: "Who swam in the Øresund straight?",
  answer: "Liam",
  photo: "/assets/liam/2025/copenhagen.png",
  caption: "I prefer drinking ice water to swimming in it",
},
{
  id: "202503",
  question: "Who taught a university Computer Science class?",
  answer: "Liam",
  photo: "/assets/liam/2025/techx.png",
  caption: "Taught them frisbee too!",
},
{
  id: "202504",
  question: "Who taught their nephew how to fist bump?",
  answer: "Liam",
  photo: "/assets/liam/2025/baby.png",
  caption: "He’s a quick learner",
},
{
  id: "202505",
  question: "Who bathed in hot springs at the Esalen Institute?",
  answer: "Liam",
  photo: "/assets/liam/2025/esalen.png",
  caption: "Found some alstroemeria",
},
{
  id: "202506",
  question: "Who pet and fed a Koala?",
  answer: "Myron",
  photo: "/assets/myron/2025/koala.png",
  caption: "Nap game respect nap game",
},
{
  id: "202507",
  question: "Who visited a Yayoi Kusama exhibit?",
  answer: "Myron",
  photo: "/assets/myron/2025/kusama.png",
  caption: "Left with a new favorite water bottle",
},
{
  id: "202508",
  question: "Who won a friendly poker tournament?",
  answer: "Myron",
  photo: "/assets/myron/2025/poker.png",
  caption: "I’m all in",
},
{
  id: "202509",
  question: "Who wore a watermelon like a helmet?",
  answer: "Myron",
  photo: "/assets/myron/2025/watermelon.gif",
  caption: "Jack-o-lantern in July",
},
{
  id: "202510",
  question: "Who went to Japan for his brother's proposal?",
  answer: "Myron",
  photo: "/assets/myron/2025/proposal.png",
  caption: "Welcome to the family, Ruyan!",
},
{
  id: "202511",
  question: "Who hiked in Yosemite during the government shutdown?",
  answer: "Max",
  photo: "/assets/max/2025/yosemite.png",
  caption: "El Capitan",
},
{
  id: "202512",
  question: "Who carried his skis to the peak of Mt. Annupuri?",
  answer: "Max",
  photo: "/assets/max/2025/mountain.png",
  caption: "Elevation training",
},
{
  id: "202513",
  question: "Who enjoyed their birthday lunch at Esquina Común in Mexico City?",
  answer: "Max",
  photo: "/assets/max/2025/lunch.png",
  caption: "¡Que deliciosa!",
},
{
  id: "202514",
  question: "Who saw different versions of The Scream at the Munch Museum in Oslo?",
  answer: "Max",
  photo: "/assets/max/2025/munch.png",
  caption: "Ahhhh!",
},
{
  id: "202515",
  question: "Who spent an entire Saturday dancing at the Pier 80 Warehouse at Portola?",
  answer: "Max",
  photo: "/assets/max/2025/portola.png",
  caption: "Best music festival in town",
},
{
  id: "202516",
  question: "Who got their motorcycle license?",
  answer: "Josh",
  photo: "/assets/josh/2025/license.png",
  caption: "biker gang",
},
{
  id: "202517",
  question: "Who worked at a Boba store for only two weeks?",
  answer: "Josh",
  photo: "/assets/josh/2025/boba.png",
  caption: "currently looking for a new job",
},
{
  id: "202518",
  question: "Who hiked through the rain alongside an active volcano in Hokkaido?",
  answer: "Josh",
  photo: "/assets/josh/2025/volcano.png",
  caption: "Mount Tokachi!",
},
{
  id: "202519",
  question: "Who ran 36 miles around the perimeter of San Francisco?",
  answer: "Josh",
  photo: "/assets/josh/2025/running.png",
  caption: "shoutout myron and liam",
},
{
  id: "202520",
  question: "Who got a parking ticket, then spilled tofu all over the floor?",
  answer: "Josh",
  photo: "/assets/josh/2025/spill.png",
  caption: "#selfcaregonewrong",
},
{
  id: "202521",
  question: "Who celebrated Walden’s wedding?",
  answer: "Jace",
  photo: "/assets/jace/2025/wedding.png",
  caption: "Machine4Lyfe",
},
{
  id: "202522",
  question: "Who pub crawled around Boston with random Irishmen?",
  answer: "Jace",
  photo: "/assets/jace/2025/pubcrawl.png",
  caption: "Cheers mate",
},
{
  id: "202523",
  question: "Who ran the pool table in Hawaii til the bar closed?",
  answer: "Jace",
  photo: "/assets/jace/2025/pool.png",
  caption: "Hustles in frisbee and in pool",
},
{
  id: "202524",
  question: "Who ski tripped in Utah while “working remotely”?",
  answer: "Jace",
  photo: "/assets/jace/2025/skitrip.png",
  caption: "Ski lift meeting",
},
{
  id: "202525",
  question: "Who cheered on a former player at a Detroit Mechanix game?",
  answer: "Jace",
  photo: "/assets/jace/2025/mechanix.png",
  caption: "RIP Mechanix",
},
];
